// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/rc-slider/assets/index.css
// module id = 679
// module chunks = 0